import { useTranslation } from "react-i18next";
import { PreOrderData } from "../../common/Interfaces";
import CustomChip from "../common/customChip/CustomChip";

interface Props {
    preOrder: PreOrderData;
}

export default function PreOrderStatus ({preOrder}: Props){
    const {t} = useTranslation();

    const showStatusData = () => {
        if (preOrder.CurrentStatus){
            return <CustomChip label={preOrder.CurrentStatus.Name}
            backColor={preOrder.CurrentStatus.BackgroundColor}
            fontColor={preOrder.CurrentStatus.ForegroundColor}/>
        }

        if (preOrder.Event){
            return <CustomChip label={preOrder.Event?.CurrentStatus?.Name}
            backColor={preOrder.Event?.CurrentStatus?.BackgroundColor}
            fontColor={preOrder.Event?.CurrentStatus?.ForegroundColor}/>
        }
        
        return <CustomChip label={t("PENDING")}/>
    }

    return (<>
        {
            showStatusData()
        }
    </>)
}